import { Routes, UrlMatcher } from '@angular/router';
import { storeIdGuard } from './menu/store-id.guard';
import { LoyaltyGuard } from './core/guards/loyalty.guard';
import { loyaltySubscriptionsGuard } from './core/guards/loyalty-subscriptions.guard';
import { safeLoadComponent } from './core/utils/safe-route-load';
import { LayoutComponent } from './core/layout/layout.component';
import { RESERVED_PATHS } from './core/constants/reserved-paths';

export const childRoutes: Routes = [
  {
    path: '',
    redirectTo: 'menu',
    pathMatch: 'full'
  },
  {
    path: 'menu',
    title: 'Browse Our Full Menu',
    // We don't need a `then` callback since we utilize default exports on menu.routes
    // see: https://angular.io/guide/standalone-components#lazy-loading-and-default-exports
    loadComponent: () => safeLoadComponent(() => import('./menu/menu/menu.component').then(c => c.MenuComponent))
  },
  {
    path: 'addCoupon',
    redirectTo: 'menu',
  },
  {
    path: 'loyalty',
    canActivate: [LoyaltyGuard],
    loadComponent: () => safeLoadComponent(() => import('./loyalty/loyalty.component').then(c => c.LoyaltyComponent))
  },
  {
    path: 'premium',
    canActivate: [LoyaltyGuard, loyaltySubscriptionsGuard],
    title: 'Premium Plans',
    loadComponent: () => safeLoadComponent(() => import('./loyalty/premium/premium.component').then(c => c.PremiumComponent))
  },
  {
    path: 'checkout',
    title: 'Checkout',
    loadChildren: () => import('./checkout/checkout.routes')
      .catch(() => [])
  },
  {
    path: 'tracker',
    redirectTo: 'checkout/enjoy',
  },
  {
    path: 'account',
    title: 'Account',
    loadChildren: () => import('./account/account.routes')
      .catch(() => [])
  },
  {
    path: 'questionnaire',
    title: 'Feedback',
    loadComponent: () => safeLoadComponent(() => import('./feedback/questionnaire/questionnaire.component').then(c => c.QuestionnaireComponent))
  },
  {
    path: 'printReceipt',
    title: 'Receipt',
    loadComponent: () => safeLoadComponent(() => import('./print-receipt/print-receipt.component').then(c => c.PrintReceiptComponent))
  },
  {
    path: 'survey',
    title: 'Survey',
    loadComponent: () => safeLoadComponent(() => import('./survey/survey.component').then(c => c.SurveyComponent))
  },
  {
    path: 'subscription-payment',
    title: 'Subscription Payment',
    canActivate: [LoyaltyGuard, loyaltySubscriptionsGuard],
    loadComponent: () => safeLoadComponent(() => import('./subscription-payment/subscription-payment.component').then(c => c.SubscriptionPaymentComponent))
  },
  {
    path: 'pay',
    title: 'QrPayment',
    loadChildren: () => import('./pay/qr-payment.routes')
      .catch(() => [])
  },
  {
    path: '**',
    redirectTo: 'menu',
    pathMatch: 'full'
  }
]


export const storeIdMatcher: UrlMatcher = (segments) => {
  if (segments.length >= 1) {
    const potentialStoreId = segments[0].path;
    // Check if the segment is not in reserved paths and matches valid store ID pattern
    // Valid store ID: alphanumeric chars, hyphens, and underscores
    if (!RESERVED_PATHS.some((path) => path.toLowerCase() === potentialStoreId.toLowerCase())) {     
      
      return {
        consumed: [ segments[0] ],
        posParams: { storeId: segments[0] }
      };
    }
  }
  return null;
};

export const routes: Routes = [
  {
    path: '404',
    title: 'Error - Page not found',
    // Route data parameters can be accessed by signal inputs - See error-page.component
    data: {
      errorTitle: 'Error - Page not found',
      errorDetails: 'The page you requested does not exist'
    },
    loadComponent: () => import('./core/error-page/error-page.component').then(c => c.ErrorPageComponent)
  },
  {
    path: 'no-store-error',
    title: 'Error - No store requested',
    data: {
      errorTitle: 'Error - No store selected',
      errorDetails: 'The link you have followed is missing the store you wish to order from'
    },
    loadComponent: () => import('./core/error-page/error-page.component').then(c => c.ErrorPageComponent)
  },
  {
    matcher: storeIdMatcher,
    title: 'Base',
    canActivateChild: [storeIdGuard],
    children: [
      {
        path: '',
        title: 'Web ordering',
        component: LayoutComponent,
        children: childRoutes
      },
    ]
  },
  {
    path: '',
    title: 'Web ordering',
    component: LayoutComponent,
    children: childRoutes
  },
];

